export class Logs {
    disputeId?: number;
    history?: Array<History>;
}

export class History {
    commentId?: number;
    dateComment?: any;
    comment?: string;
    userId?: string;
    userDesc?: string;
    timeComment?: any;
    rightComment?: any;
    leftComment?: any;
    isHeaderDate?: any;
}
